import React, { FC } from 'react';
import { Button } from 'src/components/Button';
import { Modal } from 'src/components/Modals';
import {
  ButtonsWrapper,
  ContentText,
} from 'src/components/Modals/Delete/styled';

interface ConfirmModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  text?: string;
}

export const ConfirmModal: FC<ConfirmModalProps> = ({
  open,
  onClose,
  onConfirm,
  text,
}) => (
  <Modal open={open} onClose={onClose} title="Are you sure?" small>
    <>
      <ContentText>
        {text ||
          'Are you sure you want to cancel? Any unsaved changes will be lost.'}
      </ContentText>
      <ButtonsWrapper>
        <Button type="button" fullWidth variant="outlined" onClick={onClose}>
          no
        </Button>
        <Button type="button" fullWidth variant="contained" onClick={onConfirm}>
          yes
        </Button>
      </ButtonsWrapper>
    </>
  </Modal>
);
